import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import { Col, Form, Row } from 'react-bootstrap';
import { useMyContentContext } from '../utils/myContentContext';
import Dropdown from '../../../../src/components/DropDown/index';
import { useEffect, useState } from 'react';
import { useGetCrAnswerToolsMutation } from '../../../features/authentication/qSetApiSlice';

const CreateCROption = () => {
  const {answerSize, setAnswerSize, maxPoints, setMaxPoints, editAnswer, setEditAnswer, options, setOptions,
    crAnswerToolId, setCrAnswerToolId } = useMyContentContext();
  const [crAnswerTools, setCrAnswerTools] = useState([]);
  const [getCrAnswerTools] = useGetCrAnswerToolsMutation();

  useEffect(() => {
    getCrAnswerToolsAsync();
  }, []);

  const getCrAnswerToolsAsync = async ()=>{
    const response = await getCrAnswerTools().unwrap();
    setCrAnswerTools(response);
  };

  return(
    <>
      <div className='bg-white mb-4 rounded-4 p-4'>
        <Row className='mb-5'>
          <Col>
            <div className='d-flex justify-content-between'>
              <label className='align-items-center d-flex'>Number of lines for the answer</label>
              <input
                type="text"
                value={answerSize}
                className="form-control w-15 text-lg-center text-secondary"
                id="answerSize"
                disabled={true}
              />
            </div>
            <div className="sliding-bar pt-2">
              <Slider
                min={1}
                max={100}
                value={answerSize}
                onChange={(e) => setAnswerSize(Number(e))}
                marks={{ 1: 1, 100: 100 }}
              />
            </div>
          </Col>
          <Col>
            <div className='d-flex justify-content-between'>
              <label className='align-items-center d-flex'>Maximum Points</label>
              <input
                type="text"
                value={maxPoints}
                className="form-control w-15 text-lg-center text-secondary"
                id="maxPoints"
                disabled={true}
              />
            </div>
            <div className="sliding-bar pt-2">
              <Slider
                min={1}
                max={100}
                value={maxPoints}
                onChange={(e) => setMaxPoints(Number(e))}
                marks={{ 1: 1, 100: 100 }}
              />
            </div>
          </Col>
        </Row>
        <h4 className='mb-4'>Answer Type</h4>
        <Form.Check
          inline
          label="Standard - students start with a blank answer box"
          name="answerTypeRadioGroup"
          type="radio"
          id="standardRadio"
          checked={options == 0}
          onChange={() => setOptions(0)}
          className='mr-2'
        />
        <Form.Check
          inline
          label="Edit Paragraph - students edit text"
          name="answerTypeRadioGroup"
          type="radio"
          id="editRadio"
          checked={options == 1}
          onChange={() => setOptions(1)}
          className='mr-2'
        />
        {options == 1 &&
        <div>
          <textarea
            type="text"
            className="form-control textarea-lg mt-4"
            placeholder=" "
            name="noteDescription"
            id="noteDescription"
            value={editAnswer}
            onChange={ (e)=> setEditAnswer(e.target.value)}
          />
        </div>}
        <div className='mt-4 mb-4 col-4'>
          <Dropdown
            label="CR Answer Tool"
            value={crAnswerTools}
            onChangeHandler={(e) => setCrAnswerToolId(e.target.value)}
            selectedValue={crAnswerToolId}
            dropDownName={'CR Answer Tool'}
          />
        </div>
      </div>
    </>
  );
};

CreateCROption.propTypes = {
  handleCreateSet: PropTypes.func,
  showDeletedSets: PropTypes.bool,
  handleShowDeletedChanges: PropTypes.func,
};

export default CreateCROption;